<template>
  <div>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">Trang chủ</li>
      <li class="breadcrumb-item"><a href=""> Quản lý Tin tức </a></li>
    </ol>
    <div class="container-fluid">
      <div class="col-sm-10">
        <div class="form-group">
          <router-link to="/admin/news/add" class="btn btn-sm btn-primary">
            <i class="fas fa-plus"></i>
            Thêm mới Tin tức
          </router-link>
        </div>
      </div>

      <div>
        <form method="post" @submit="mySearch" id="my_search">
          <div class="row">
            <div class="col-sm-5 mb-3">
              <input
                type="text"
                name="name"
                class="form-control"
               
                autocomplete="off"
                placeholder="Nhập tên..."

                v-model="formSearch.name"
              />

              <button class="btn btn-sm btn-warning mt-3" type="submit">
                <i class="fa fa-search-plus"></i> TÌM KIẾM
              </button>
            </div>
             <div class="col-sm-5 mb-3" >
                          <select
                            class="form-control"
                            name="cate"
                            v-model="formSearch.cate"
                          >
                            <option value="">Tùy chọn</option>
                            <template v-for="elm in mycate">
                              <option
                                :value="elm.id"
                                :key="elm.id"
                                v-if="elm.parentId == null"
                              >
                                {{ elm.name }}
                              </option>

                             
                            </template>
                          </select>
              
            </div>
          </div>
        </form>

      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header" v-if="is_loading">
              <SkeletonTheme color="#e6f3fd" highlight="#eef6fd">
                <Skeleton width="40px" height="40"></Skeleton>
              </SkeletonTheme>
            </div>
            <div class="card-header" v-else>
              <i class="fa fa-align-justify" v-if="mydata != null"></i> Quản lý
              Tin tức  : ( {{ page_size }} )
            </div>
            <div class="card-block">
              <SkeletonTheme color="#e6f3fd" highlight="#eef6fd">
                <table class="table table-sm">
                  <thead>
                    <tr>
                       <th>STT</th>
                        <th>
                          <button @click="removeAll" type="button" class="btn btn-small btn-danger"> Xoá </button>
                        </th>
                      <th>
                          <a href="javascript:;" @click="orderByName()">
                            Tên
                            <i  class="fas fa-angle-down" :class="{'fa-angle-up':orderby.name=='ASC'}"></i>
                          </a>
                      </th>
                      <th>User</th>
                      <th>Ngày tạo</th>
                      <th>Ngày sửa </th>
                      <th>

                        <a href="javascript:;" @click="orderByParent()">
                            Danh mục
                            <i  class="fas fa-angle-down" :class="{'fa-angle-up':orderby.parent=='ASC'}"></i>
                            
                          </a>

                      </th>

                    
                       <th>


                        <a href="javascript:;" @click="orderByCate()">
                           Danh mục con
                            <i  class="fas fa-angle-down" :class="{'fa-angle-up':orderby.cate=='ASC'}"></i>
                          </a>
                          
                           </th>
                      <th>Tuỳ chọn</th>
                    </tr>
                  </thead>
                  <tbody v-if="is_loading">
                    <tr v-for="(el, k) in 10" :key="k">
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <Skeleton height="40px"></Skeleton>
                      </td>
                      <td>
                        <a href="" target="_black" class="text text-primary">
                          <Skeleton></Skeleton>
                        </a>
                        <br />

                        <a href="" target="_black" class="text text-primary">
                          <Skeleton></Skeleton>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr
                      v-for="(value, key) in mydata"
                      :Key="key"
                    >
                      <td>{{key+1+(page*20-20)}}</td>
                      <td>
                         <input v-if="isLogin.indexOf(value.parentId)>-1" type="checkbox" :value="value.id" v-model="is_remove" />
                      </td>
                      <td style="width: 400px;">
                        <a
                          :href="'/vn/ben-xe-mien-dong/' + value.slug"
                          class="text text-primary"
                          target="_black"
                        >
                          {{ value.name }}
                        </a>
                        <br />
                     
                        <template v-if="value.picture !== null">
                          <img
                            :src="my_url + '' + value.picture"
                            :title="value.picture"
                            width="100px"
                          />
                        </template>
                      </td>
                      <td>
                          {{value.userCreate}}
                      </td>
                      <td>
                          {{value.createdTime.substring(0,10)}}
                      </td>
                      <td>
                          {{value.modifiedTime.substring(0,10)}}
                      </td>
                     
                      <td >
                        {{ value.parentId | ViewCate(mycate) }}
                      </td>
                       <td >
                        {{ value.cateId | ViewCate(mycate) }}
                      </td>


                      <td v-if="role==1 ||  isLogin.indexOf(value.parentId)>-1">
                        <router-link
                          class="btn btn-sm btn-success"
                          v-bind:to="'/admin/news/edit/' + value.id"
                        >
                          <i class="fa fa-edit"></i>
                          Sửa
                        </router-link>
                        <div
                          class="btn btn-sm btn-danger click_remove"
                          @click="removeElement(value.id)"
                        >
                          <i class="fa fa-remove"></i> Xoá
                        </div>

                        <p> {{value.SubmitDate}}</p>
                      </td>

                      <td v-else>
                        <p>Không Truy cập </p>
                         <div
                          v-if="language=='en'"
                          class="btn btn-sm btn-danger click_remove"
                          @click="removeElement(value.id)"
                        >
                          <i class="fa fa-remove"></i> Xoá
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <nav v-if="mydata != null && mydata.length > 1">
                  <VuePagination
                    :page-count="Math.ceil(page_size/20)"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="changePage"
                    :prev-text="'Prev'"
                    :next-text="'Next'"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                  >
                  </VuePagination>
                </nav>
              </SkeletonTheme>
            </div>
          </div>
        </div>
        <!--/.col-->
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton, SkeletonTheme } from "vue-loading-skeleton";
import VuePagination from "vuejs-paginate";
import axios from "axios";
export default {
  name: "News.List",
  data() {
    return {
      is_loading: true,
      form: {},
      mydata: null,
      main:null,
      search: "",
      page: 1,
      id_load: "",
      mycate:null,
      my_url: window.my_url,

      page_size:0,
      is_remove:[],

      isLogin:null,
      formSearch:{
         name:"",
          cate:""
      },
      orderby:{
        name:"ASC",
        cate:"ASC",
        parent:"ASC"
      },
      language: window.my_header.language,
      role:2
    };
  },
  components: {
    Skeleton,
    SkeletonTheme,
    VuePagination,
  },
  filters:{
    ViewCate:function(id_cate,mycate){
        var result= mycate.filter( (n)=> n.id==id_cate);
        if(result.length){
            return result[0].name;
        }
        return "";


    }

  },
  created(){  
      let isLogin= this.$session.get("isLogin");
      this.isLogin=isLogin.permistions.split(",");

      let Customer= this.$session.get("Customer");
      this.role=Customer.isRole;
  },
  mounted() {

   let p1= axios
      .get(window.my_api + "api/newscate/get-newscates", {
        headers: window.my_header
      })
      .then((res) => {
        if (res.status == 200) {
          this.mycate = res.data.data;
          
        } else {
          alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
        }
      });


   let p2=  axios
      .get(window.my_api + "api/news/get-cms-news", {
        headers: window.my_header
      })
      .then((res) => {
        if (res.status == 200) {
          this.mydata = this.main = res.data.data.records;
          this.page_size=res.data.data.total;
          this.mydata.sort((a, b) => a.orderBy - b.orderBy);
          
        } else {
          alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
        }
      });

      Promise.all([p1,p2])
             .then( ()=>{
                this.is_loading = false;
             });
  },
  methods: {
    orderByName(){

        if(this.orderby.name=="ASC"){
            this.orderby.name="DESC";
        }else{
          this.orderby.name="ASC";
        }
       
         this.page = 1;
          axios.get(window.my_api + "api/news/get-cms-news?page="+1, 
            {
              params:{
                  "column":"name",
                  "sort":this.orderby.name
              },
              headers: window.my_header
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.mydata = res.data.data.records;
              
              
              
            } else {
              alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
            }
          });
    },
    orderByParent(){
        if(this.orderby.parent=="ASC"){
            this.orderby.parent="DESC";
        }else{
          this.orderby.parent="ASC";
        }
        
         this.page = 1;
          axios.get(window.my_api + "api/news/get-cms-news?page="+1, 
            {
              params:{
                  "column":"parentId",
                  "sort":this.orderby.parent
              },
              headers: window.my_header
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.mydata = res.data.data.records;
              
              
              
            } else {
              alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
            }
          });
    },
    orderByCate(){
        if(this.orderby.cate=="ASC"){
            this.orderby.cate="DESC";
        }else{
          this.orderby.cate="ASC";
        }


          this.page = 1;
          axios.get(window.my_api + "api/news/get-cms-news?page="+1, 
            {
              params:{
                  "column":"cateId",
                  "sort":this.orderby.cate
              },
              headers: window.my_header
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.mydata = res.data.data.records;
              
              
              
            } else {
              alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
            }
          });
    },
    changePage(e) {
      this.page = e;
      axios.get(window.my_api + "api/news/get-cms-news?page="+e, 
        {
          
          headers: window.my_header
        }
      )
      .then((res) => {
        if (res.status == 200) {
          this.mydata = res.data.data.records;
          
          
          
        } else {
          alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
        }
      });
      
    },
    paginationslice(data, page) {
     return   axios.get(window.my_api + "api/news/get-cms-news?page="+page,
          {
              headers: window.my_header
          }
      )
      .then((res) => {
        if (res.status == 200) {
          data = res.data.data.records;
          
          return data;
          
        } else {
          alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
        }
      });


      // return data.filter((value, n) => {
      //   return n >= pagesize * (page - 1) && n < pagesize * page;
      // });
    },
    mySearch(event) {
      event.preventDefault();
       this.page = 1;
       console.log(this.formSearch);
      axios
        .get(window.my_api + "api/news/get-cms-news",{
            headers: window.my_header,
            params:{
              page:this.page,
              keyword:this.formSearch.name,
              catetegory:this.formSearch.cate

            }

        })
        .then((res) => {
          if (res.status == 200) {
            this.mydata = this.main = res.data.data.records;
            this.page_size=res.data.data.total;
            this.mydata.sort((a, b) => a.orderBy - b.orderBy);
             
          } else {
            alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
          }
          this.is_loading = false;
        });
      return false;
        
      // var form =new FormData(document.getElementById("my_search") ) ;

      // this.mydata=this.main.filter( (n)=>{
      //       if(form.get("name").length && form.get("cate").length){
      //         return   (n.cateId == form.get("cate") || n.parentId== form.get("cate")) && n.name.search(form.get("name") ) > -1;
      //       }
      //       if(form.get("name").length){
      //         return    n.name.search(form.get("name") ) > -1;
      //       }
      //       if(form.get("cate").length){
      //         return   (n.cateId == form.get("cate") || n.parentId== form.get("cate")) ;
      //       }
      //       return n;


      // });

      // return false;
      // axios
      //   .get(window.my_api + "api/news/get-cms-news?Search=" + this.search)
      //   .then((res) => {
      //     if (res.status == 200) {
      //       this.mydata = res.data.data;
      //       this.page = 1;
      //     } else {
      //       alert("Hệ thống không hoạt động, vui lòng liên hệ với Admin.");
      //     }
      //     this.is_loading = false;
      //   });
    },
    removeAll(){
        
        if(this.is_remove.length > 0){
           for (var i = this.is_remove.length - 1; i >= 0; i--) {
            
              this.removeElement(this.is_remove[i]);
            }
        }
        return false;
         
    },
    removeElement(id) {
      this.$swal
        .fire({
          title: "Bạn có muốn xóa?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.id_load = id;
            axios
              .delete(window.my_api + "api/news/remove-news", {
                data: { newsIds: [id] },
                headers: window.my_header
              })
              
              .then((res) => {
                if (res.status == 200) {
                  this.$swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Xóa thành công.",
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.mydata = this.mydata.filter((el) => el.id !== id);
                } else {
                  alert(
                    "Hệ thống không hoạt động, vui lòng liên hệ với Admin."
                  );
                }
                this.id_load = "";
              });
          }
        });
    },
  },
};
</script>








